import { css, jsx } from '@emotion/core';
import React from 'react';

import ContentPage from '@/src/cms/components/CMSPage/Content';
import { requestStaticContent } from '@/src/cms/utils';
import { bp } from '@/styles';

function AboutUs(props) {
  return (
    <ContentPage
      {...props}
      bodyStyle={css`
        > div > ul {
          display: block;
          list-style-position: inside;
          @media ${bp.sm} {
            margin-left: 32px;
          }
          > li {
            list-style-type: disc;
          }
        }
        .c-table-about {
          @media (max-width: ${bp.sizes.sm}px) {
            display: block;
            margin: 0 0 16px;
            width: 100%;

            * {
              display: block;
              padding: 0 !important;
              width: 100%;
            }

            tr [bgcolor] {
              padding: 4px !important;
            }
          }
        }
      `}
    />
  );
}

export async function getStaticProps() {
  const sitepageid = 55493;
  const pagedata = await requestStaticContent(sitepageid);
  return { props: { sitepageid, pagedata } };
}

export default AboutUs;
